import React, { useEffect, useRef, useState } from 'react';
import emailjs from '@emailjs/browser';

export default function Contact() {
  const formRef = useRef(null);
  const [messageText, setMessageText] = useState('');

  useEffect(() => {
    // show scroll-up button
    const scrollUp = () => {
      const scrollUpEl = document.getElementById('scroll-up');
      if (!scrollUpEl) return;
      window.scrollY >= 350 ? scrollUpEl.classList.add('show-scroll') : scrollUpEl.classList.remove('show-scroll');
    };
    window.addEventListener('scroll', scrollUp);
    return () => window.removeEventListener('scroll', scrollUp);
  }, []);

  const sendEmail = (e) => {
    e.preventDefault();
    // replace service/template/publicKey with your values (these were in your original main.js)
    emailjs.sendForm('service_v8aigc8', 'template_np1aymj', formRef.current, 'KZ5PylRq5NP2Pj9VK')

// emailjs.sendForm(
//   import.meta.env.VITE_EMAIL_SERVICE,
//   import.meta.env.VITE_EMAIL_TEMPLATE,
//   formRef.current,
//   import.meta.env.VITE_EMAIL_PUBLIC
// )
      .then(() => {
        setMessageText('Message Send Successfully ✅');
        setTimeout(() => setMessageText(''), 5000);
        formRef.current.reset();
      }, () => {
        setMessageText('Message not send (service error) ❌');
      });
  };

  return (
    <section className="contact section" id="contact">
      <div className="contact__container grid">
        <div className="contact__data">
          <h2 className="section__title-2 ">
            <span className="">Contact Me.</span>
          </h2>

          <p className="contact__description-1">I will read all emails. Send me any message you want and I'll get back to you.</p>
          <p className="contact__description-2">
            I need your <b>Name</b> and <b>Email Address</b>, but you won't receive anything other than your reply.
          </p>
          <div className="geometric-box"></div>
        </div>

        <div className="contact__mail">
          <h2 className="contact__title">Send Me A Message</h2>

          <form ref={formRef} className="contact__form" id="contact-form" onSubmit={sendEmail}>
            <div className="contact__group">
              <div className="contact__box contact__name">
                <input type="text" name="user_name" className="contact__input" id="name" required placeholder="First Name" />
                <label htmlFor="name" className="contact__label">First Name</label>
              </div>

              <div className="contact__box">
                <input type="email" name="user_email" className="contact__input" id="email" required placeholder="Email Address" />
                <label htmlFor="email" className="contact__label">Email Address</label>
              </div>
            </div>

            <div className="contact__box">
              <input type="text" name="user_subject" className="contact__input" id="subject" required placeholder="Subject" />
              <label htmlFor="subject" className="contact__label">Subject</label>
            </div>

            <div className="contact__box contact__area">
              <textarea name="user_message" id="message" className="contact__input" required placeholder="Message"></textarea>
              <label htmlFor="message" className="contact__label">Message</label>
            </div>

            <p className="contact__message" id="contact-message">{messageText}</p>

            <button type="submit" className="contact__button button">
              <i className="ri-send-plane-line"></i> Send Message
            </button>
          </form>
        </div>

        <div className="contact__social">
          <img src="../../assets/curved-arrow.svg" alt="" className="contact__social-arrow" />

          <div className="contact__social-data">
            <div>
              <p className="contact__social-description-1">Does not send emails</p>
              <p className="contact__social-description-2">Write me on my social networks</p>
            </div>

            <div className="contact__social-links">
                 <a href="https://instagram.com/trakiteam" target="_blank" rel="noreferrer" className="contact__social-link"><i className="ri-instagram-line"></i></a>
              <a href="https://linkedin.com/in/rohitbarsainya" target="_blank" rel="noreferrer" className="contact__social-link"><i className="ri-linkedin-line"></i></a>
            <a href="https://wa.me/917879137990" target="_blank" rel="noreferrer" className="home__social-link"> <i className="ri-whatsapp-line"></i> </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
